import Vue from "vue";
import "element-ui/lib/theme-chalk/index.css";

// import Element from 'element-ui'

// Vue.use(Element)

// or 局部引入
import {
  Scrollbar,
  Pagination,
  Button,
  DatePicker,
  Message,
  Loading,
  Dialog,
  Table,
  Radio,
  Checkbox,
  Form,
  Input,
  Select,
  Option,
  FormItem,
  cascader,
  Tag,
  Slider,
  RadioGroup,
  RadioButton
} from "element-ui";

const COMPONENTS = [
  Scrollbar,
  Pagination,
  Button,
  DatePicker,
  Message,
  Dialog,
  Table,
  Radio,
  Checkbox,
  Form,
  Input,
  Select,
  Option,
  FormItem,
  cascader,
  Tag,
  Slider,
  RadioGroup,
  RadioButton
];

// 注册组件
COMPONENTS.forEach(item => {
  Vue.component(item.name, item);
});

// 方法
Vue.prototype.$message = Message;
Vue.prototype.$Loading = Loading;
